export enum HospitalActionTypes {
  GET_HOSPITALS = "@@HOSPITAL/GET_HOSPITALS",
  GET_HOSPITALS_SUCCESS = "@@HOSPITAL/GET_HOSPITALS_SUCCESS",
  GET_HOSPITALS_FAILURE = "@@HOSPITAL/GET_HOSPITALS_FAILURE",

  GET_HOSPITAL_FORMS_SETTINGS = "@@HOSPITAL/GET_HOSPITAL_FORMS_SETTINGS",
  GET_HOSPITAL_FORMS_SETTINGS_SUCCESS = "@@HOSPITAL/GET_HOSPITAL_FORMS_SETTINGS_SUCCESS",
  GET_HOSPITAL_FORMS_SETTINGS_FAILURE = "@@HOSPITAL/GET_HOSPITAL_FORMS_SETTINGS_FAILURE",

  UPDATE_HOSPITAL_FORM_SETTING = "@@HOSPITAL/UPDATE_HOSPITAL_FORM_SETTING",
  UPDATE_HOSPITAL_FORM_SETTING_SUCCESS = "@@HOSPITAL/UPDATE_HOSPITAL_FORM_SETTING_SUCCESS",
  UPDATE_HOSPITAL_FORM_SETTING_FAILURE = "@@HOSPITAL/UPDATE_HOSPITAL_FORM_SETTING_FAILURE",

  GET_HOSPITAL = "@@HOSPITAL/GET_HOSPITAL",
  GET_HOSPITAL_SUCCESS = "@@HOSPITAL/GET_HOSPITAL_SUCCESS",
  GET_HOSPITAL_FAILURE = "@@HOSPITAL/GET_HOSPITAL_FAILURE",

  GET_HOSPITAL_PERMISSIONS = "@@HOSPITAL/GET_HOSPITAL_PERMISSIONS",
  GET_HOSPITAL_PERMISSIONS_SUCCESS = "@@HOSPITAL/GET_HOSPITAL_PERMISSIONS_SUCCESS",
  GET_HOSPITAL_PERMISSIONS_FAILURE = "@@HOSPITAL/GET_HOSPITAL_PERMISSIONS_FAILURE",

  UPPDATE_HOSPITAL_PERMISSION = "@@HOSPITAL/UPPDATE_HOSPITAL_PERMISSION",
  UPPDATE_HOSPITAL_PERMISSION_SUCCESS = "@@HOSPITAL/UPPDATE_HOSPITAL_PERMISSION_SUCCESS",
  UPPDATE_HOSPITAL_PERMISSION_FAILURE = "@@HOSPITAL/UPPDATE_HOSPITAL_PERMISSION_FAILURE",

  UPDATE_HOSPITAL = "@@HOSPITAL/UPDATE_HOSPITAL",
  UPDATE_HOSPITAL_SUCCESS = "@@HOSPITAL/UPDATE_HOSPITAL_SUCCESS",
  UPDATE_HOSPITAL_FAILURE = "@@HOSPITAL/UPDATE_HOSPITAL_FAILURE",

  CLEAR_HOSPITALS = "@@HOSPITAL/CLEAR_USERS",
  SET_FILTER = "@@HOSPITAL/SET_FILTER",
  SET_SELECTED_HOSPITAL_OPTION = "@@HOSPITAL/SET_SELECTED_HOSPITAL_OPTION",
}
